import React, { useState, useEffect } from 'react';
import { Box, Typography, Snackbar, Alert, Fade, Divider, Button } from '@mui/material';
import loginbg from '../assets/images/new-background.png';
// import loginbg from "../assets/images/otp-bg.png";
import NewLogo from '../assets/images/Layer_1nu.png';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingButton from '@mui/lab/LoadingButton';

import { MuiOtpInput } from 'mui-one-time-password-input';
import { logIn } from '../redux/reducers/login';
import { loginCognitoUser } from '../graphql/';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { showSuccessSnackbar } from '../components/snackBar/snakbar';

const ConfirmSignUp = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const [state, setState] = useState({
    code: '',
    open: false,
    timer: '00:30',
    showCountdown: true,
    errorStatus: {
      code: false,
    },
    errorFields: {
      code: '',
      open: '',
    },
  });
  const [otp, setOtp] = useState('');
  const handleChangeOTP = (newValue) => {
    setOtp(newValue);

    if (newValue.length === 6) {
      setState((prev) => ({
        ...prev,
        code: newValue,
        errorStatus: {
          ...prev.errorStatus,
          code: false,
        },
        errorFields: {
          ...prev.errorFields,
          code: '',
        },
      }));
    }
  };

  let location = useLocation();
  let params = location.state;
  const { status } = params;
  let horizontal = matches ? 'center' : 'left';
  let vertical = matches ? 'top' : 'bottom';

  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);

  // useEffect(() => {
  //   if (state.showCountdown) {
  //     const startTime = Date.parse(localStorage.getItem("startTime"));
  //     let seconds = 0;
  //     let minutes = 0;
  //     if (Date.parse(new Date()) - startTime < 90000) {
  //       const coutDown = setInterval(() => {
  //         const total = startTime + 90000 - Date.parse(new Date());
  //         seconds = Math.floor((total / 1000) % 60);
  //         minutes = Math.floor((total / 1000 / 60) % 60);
  //         // console.log(minutes,seconds);
  //         setState((prev) => ({
  //           ...prev,
  //           timer:
  //             (minutes > 9 ? minutes : "0" + minutes) +
  //             ":" +
  //             (seconds > 9 ? seconds : "0" + seconds),
  //         }));
  //         if (minutes == 0 && seconds == 0) {
  //           clearInterval(coutDown);
  //           setState((prev) => ({
  //             ...prev,
  //             showCountdown: false,
  //           }));
  //         }
  //       }, 1000);
  //     } else {
  //       setState((prev) => ({
  //         ...prev,
  //         showCountdown: false,
  //       }));
  //     }
  //   }
  // }, [state.showCountdown]);

  useEffect(() => {
    let confirmTimmer;

    if (timer <= 0) {
      setState((pre) => ({
        ...pre,
        showCountdown: false,
      }));
      clearInterval(confirmTimmer);
    } else {
      confirmTimmer = setInterval(() => {
        setTimer((pre) => pre - 1);
      }, 1000);
    }

    return () => {
      clearInterval(confirmTimmer);
    };
  }, [timer]);

  async function resendCode() {
    let username = params.email;

    try {
      // Send confirmation code to user's email
      await Auth.resendSignUp(username)
        .then((data) => {
          // localStorage.setItem("startTime", new Date());
          setTimer(30);
          setState((prev) => ({
            ...prev,
            showCountdown: true,
          }));

          setState((prev) => ({
            ...prev,
            open: false,
            errorFields: {
              ...prev.errorFields,
              open: '',
            },
          }));

          showSuccessSnackbar('Verification code sent again.');
        })
        .catch((error) => {
          setState((prev) => ({
            ...prev,
            open: true,
            errorFields: {
              ...prev.errorFields,
              open: error.message,
            },
          }));
        });
    } catch (error) {
      console.log('error : ', error);
    }
  }

  const closeSnackbar = () => {
    setState((prev) => ({
      ...prev,
      open: false,
      errorFields: {
        ...prev.errorFields,
        open: '',
      },
    }));
  };

  const onChangeEvent = (event) => {
    const { name, value } = event.target;

    if (value !== '') {
      if (!new RegExp(/^\d+$/).test(value)) {
        setState((prev) => ({
          ...prev,
          [name]: value,
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: 'Invalid Confirmation Code',
          },
        }));
      } else if (value.trim().length > 0 && value.trim().length !== 6) {
        setState((prev) => ({
          ...prev,
          [name]: value,
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: 'Please enter your 6 digits code',
          },
        }));
      } else {
        setState((prev) => ({
          ...prev,
          [name]: value,
          errorStatus: {
            ...prev.errorStatus,
            [name]: false,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: '',
          },
        }));
      }
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: 'Confirmation code is required',
        },
      }));
    }
  };

  const handleFormSubmission = (event) => {
    event.preventDefault();

    const { code } = state;

    const formData = {
      code: code,
    };

    if (formValidation(formData)) {
      setLoading(true);
      confirmingSignUp(formData);
    }
  };

  async function confirmingSignUp(values) {
    try {
      let code = values.code;

      const { email, password, status } = params;
      //Validate confirmation code
      console.log(email, password, { params });
      await Auth.confirmSignUp(email, code);

      //Sign in the user after verification of code
      if (status === 'unverified') {
        await Auth.forgotPassword(email);
        localStorage.setItem('startTime', new Date());
        showSuccessSnackbar('Account verified ! Now you can reset the password.');
        return navigate('/newPassword', { state: { email: email, status } });
      }
      try {
        await Auth.signIn(email, password);
        const devicekey = Date.now()?.toString();
        localStorage.setItem('deviceKey', devicekey);
        let createSession = await API.graphql(graphqlOperation(loginCognitoUser, { LinkedSessionID: devicekey }));
        localStorage.setItem('sessionID', createSession.data.loginCognitoUser.sessionid);
        dispatch(logIn());
        localStorage.setItem('firstTimeUser', 1);
        navigate('/');
      } catch (error) {
        navigate('/login');
        setLoading(false);
      }

      //   await Auth.signIn(email, password).catch((err) => {
      //     navigate("/login");
      //     setLoading(false)
      //   }
      //   );
      localStorage.setItem('UserNameDisplay', true);
      setState((prev) => ({
        ...prev,
        open: false,
        errorFields: {
          ...prev.errorFields,
          open: '',
        },
      }));
      setLoading(false);
    } catch (error) {
      console.log('error : ', error);
      setState((prev) => ({
        ...prev,
        open: true,
        errorFields: {
          ...prev.errorFields,
          open: error.message,
        },
      }));
      setLoading(false);
    }
  }

  const formValidation = (data) => {
    let isvalid = true;

    Object.keys(data).map((itemKey) => {
      if (itemKey === 'code') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Confirmation code is required',
            },
          }));
        } else if (!new RegExp(/^\d+$/).test(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Invalid Confirmation Code',
            },
          }));
        } else if (data[itemKey].trim().length > 0 && data[itemKey].trim().length !== 6) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Please enter your 6 digits code',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }
    });

    return isvalid;
  };

  return (
    <Fade in={true}>
      <Box
        sx={{
          // display: "flex",
          // // flexDirection: {
          // //     xs: 'column',
          // //     md: 'row'
          // // },
          // alignItems: {
          //     xs: 'center',
          //     md: 'normal'
          // },
          // justifyContent: {
          //     xs: 'center',
          //     md: 'normal'
          // },
          // backgroundImage: {
          //     xs: `url(${loginbg})`,
          //     md: 'none'
          // },
          // // backgroundPosition: "left",
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'auto 100%',
          backgroundImage: `url(${loginbg})`,
          backgroundColor: '#e7e7e7',
          width: '100%',
          minHeight: '100vh',
          // height: "100%",

          // padding: {
          //     xs: '20px 20px',
          //     sm: '30px 40px',
          //     md: '0px 0px'
          // },
          // boxSizing: 'border-box',
        }}
      >
        {/* {!matches ?
                    <Box sx={{
                        // flex : 1,
                        backgroundImage: `url(${loginbg})`,
                        backgroundPosition: "left",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "auto 100%",
                        width: "55%",
                        height: "100vh",
                        display: "flex",
                        // justifyContent : "center",
                        alignItems: "center",
                        paddingLeft: "60px",
                        paddingRight: "60px",
                    }}>

                        <Box sx={{
                            height: {
                                md: "290px",
                                lg: "270px"
                            },
                            width: "100%",
                            // backgroundImage: `url(${textBg})`,
                            backgroundSize: "auto 80%",
                            backgroundRepeat: "no-repeat",
                            position: "relative",
                        }}>
                            <Box sx={{
                                position: "absolute",
                                left: 50,
                                top: 35,
                            }}>

                                <Typography variant="h4" sx={{ color: "black", marginBottom: "15px" }}>
                                    Confirmation <span style={{ fontWeight: "bold" }}>screen</span>
                                </Typography>

                                <Typography sx={{ color: "black", marginBottom: "30px" }}>
                                    We've sent you a verification code to this Email address <span style={{ color: 'black' }}>{params?.email} </span>
                                    Please enter the code here to verify your account
                                </Typography>

                                {
                                    state.showCountdown ?
                                        <Typography style={{ textDecoration: 'none', color: 'white' }} >
                                            Resend code in {state.timer}
                                        </Typography>

                                        :
                                        <Box
                                            sx={{
                                                backgroundColor: "#75428C",
                                                maxWidth: "240px",
                                                padding: "12px 15px",
                                                textAlign: "center",
                                                borderRadius: "20px",
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => resendCode()}
                                        >

                                            <Typography style={{ textDecoration: 'none', color: '#fff' }} >
                                                Resend the code
                                            </Typography>

                                        </Box>
                                }
                            </Box>

                        </Box>

                    </Box>
                    :
                    <Box sx={{
                        width: {
                            xs: '90%',
                            sm: '80%',
                            md: '45%',
                            lg: '45%'
                        },
                        marginBottom: {
                            xs: '30px',
                            sm: '60px',
                            md: '0px'
                        }
                    }}>

                        <Typography variant="h4" sx={{
                            color: "black",
                            marginBottom: "15px",
                            textAlign: {
                                xs: 'center',
                                md: 'left'
                            }
                        }}>
                            Confirmation <span style={{ fontWeight: "bold" }}>screen</span>
                        </Typography>

                        <Typography sx={{
                            color: "black", marginBottom: "15px",
                            textAlign: {
                                xs: 'center',
                                md: 'left'
                            }
                        }}>
                            We've sent you a verification code to this Email address <span style={{ color: 'black' }}>{params?.email} </span>
                            Please enter the code here to verify your account
                        </Typography>

                        {
                            state.showCountdown ?
                                <Typography style={{ textAlign: 'center', color: '#fff' }} >
                                    Resend code in {state.timer}
                                </Typography>
                                :
                                <Box
                                    sx={{
                                        backgroundColor: "#75428C",
                                        maxWidth: "240px",
                                        padding: "12px 15px",
                                        textAlign: "center",
                                        borderRadius: "20px",
                                        cursor: 'pointer',
                                        margin: {
                                            xs: '0px auto',
                                            md: '0px'
                                        }
                                    }}
                                    onClick={() => resendCode()}
                                >

                                    <Typography style={{ textDecoration: 'none', color: '#fff' }} >
                                        Resend the code
                                    </Typography>

                                </Box>
                        }
                    </Box>
                } */}

        {/* Toast */}
        <Snackbar open={state.open} autoHideDuration={6000} anchorOrigin={{ horizontal, vertical }} onClose={closeSnackbar}>
          <Alert onClose={closeSnackbar} variant="filled" severity="error" sx={{ width: '100%' }}>
            {state.errorFields.open}
          </Alert>
        </Snackbar>

        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(29, 14, 33, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              height: '100vh',
              // backgroundColor: "#e7e7e7",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '750px',
              paddingLeft: {
                xs: '0px',
                md: '30px',
              },
              paddingRight: {
                xs: '0px',
                md: '30px',
              },
            }}
          >
            {/* Toast */}
            <Snackbar open={state.open} autoHideDuration={6000} anchorOrigin={{ horizontal, vertical }} onClose={closeSnackbar}>
              <Alert onClose={closeSnackbar} variant="filled" severity="error" sx={{ width: '100%' }}>
                {state.errorFields.open}
              </Alert>
            </Snackbar>

            <Box
              sx={{
                width: '100%',
                boxShadow: 'rgba(0, 0, 0, 0.25) 0px 4px 4px 0px',
                padding: { sm: '40px', xs: '10px' },
                background: {
                  xs: '#f7f7f7',
                  md: '#f7f7f7',
                },
                borderRadius: '15px',
              }}
            >
              <Box sx={{ textAlign: 'center', marginBottom: { xs: '5px', sm: '10px' } }}>
                <Box
                  component={'div'}
                  class="image"
                  sx={{
                    height: { xs: '55px', sm: '85px' },
                    maxWidth: '300px',
                    backgroundImage: `url(${NewLogo})`,
                    backgroundSize: 'auto 100%',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    margin: '0 auto',
                  }}
                ></Box>
              </Box>
              {/* <div 
                            style={{ width: "100%" }}
                            > */}

              <Typography
                sx={{
                  color: '#75428C',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '28px',
                  fontFamily: 'Overpass',
                  fontWeight: '600',
                }}
              >
                Account Confirmation
              </Typography>
              {status === 'unverified' && (
                <p
                  style={{
                    color: 'red',
                    textAlign: 'center',
                  }}
                >
                  You need to verify the account before reseting password !
                </p>
              )}
              <Typography
                sx={{
                  color: '#75428C',
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'center',
                  fontSize: { xs: '12px', sm: '14px' },
                  marginBottom: '20px',
                }}
              >
                Please enter the Verification code sent to your email (<span style={{ color: '#1492ccff' }}>{params?.email}</span>).
              </Typography>
              {/* </div> */}
              <form
                onSubmit={(event) => handleFormSubmission(event)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleFormSubmission(e);
                  }
                }}
              >
                <Box sx={{ width: { xs: '90%', sm: '80%' }, margin: '0 auto' }}>
                  <MuiOtpInput
                    sx={{ width: '100%', gap: { sm: 'auto', xs: '10px' } }}
                    autoFocus={true}
                    value={otp}
                    onChange={handleChangeOTP}
                    length={6}
                  />
                </Box>
                {/* <CustomInputBox
                                    name='code'
                                    placeholder='code'
                                    type='text'
                                    autoFocus={true}
                                    onChange={onChangeEvent}
                                    state={state}
                                    icon={<Security sx={{ color: (state.errorStatus.code === true) ? "danger.main" : "#8a8787" }} className="icon" />}
                                /> */}

                <Box
                  sx={{
                    justifyContent: 'space-between',
                    marginTop: { sm: '20px', xs: '10px' },
                    marginBottom: { sm: '20px', xs: '10px' },
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Typography sx={{ fontSize: '14px', color: '#75428C' }}>Not received OTP ?</Typography>
                    {state.showCountdown ? (
                      <Typography sx={{ fontSize: '14px', color: '#75428C' }}>Resend in 00:{timer <= 9 ? '0' + timer : timer} </Typography>
                    ) : (
                      <Button variant="contained" sx={{ fontSize: '10px' }} onClick={() => resendCode()}>
                        Resend code
                      </Button>
                    )}
                  </Box>
                  <Box sx={{ flex: 1, textAlign: 'right' }}>
                    {/* <Button variant="contained" disableRipple={true} onClick= {(event) => handleFormSubmission(event)}> Submit </Button> */}
                    <LoadingButton
                      sx={{ width: { xs: 120, sm: 160 }, height: { xs: 'auto', sm: 50 }, background: '#75428C' }}
                      loading={loading}
                      disableRipple={true}
                      variant="contained"
                      onClick={(event) => handleFormSubmission(event)}
                    >
                      Submit
                    </LoadingButton>
                  </Box>
                </Box>
              </form>
              <Box sx={{ flex: 1, textAlign: 'left', padding: '0px', fontSize: { sm: '14px', xs: '12px' } }}>
                <Link to="/" underline="hover" color="blue">
                  Back to Login
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default ConfirmSignUp;
